import BasicResource from '@/api/resource';

class AnalyticsResource extends BasicResource {

    constructor () {
        super('analytics');
    }

    timeseries (params) {
        return this.client.request ({
            method: 'get',
            path: '/upyield/v2/analytics/timeseries',
            params,
        });
    }

    pivot (params) {
        return this.client.request ({
            method: 'get',
            path: '/upyield/v2/analytics/pivot',
            params,
        });
    }

    pivotFraud (params) {
        return this.client.request ({
            method: 'get',
            path: '/upyield/v2/analytics/pivot/fraud',
            params,
        });
    }

    pivotDownload (params) {
        return this.client.download ({
            method: 'get',
            responseType: 'blob',
            path: '/upyield/v2/analytics/pivot/download',
            params,
        });
    }

    pivotFraudDownload (params) {
        return this.client.download ({
            method: 'get',
            responseType: 'blob',
            path: '/upyield/v2/analytics/pivot/fraud/download',
            params,
        });
    }

    overview (params) {
        return this.client.request ({
            method: 'get',
            path: '/upyield/v2/analytics/overview',
            params,
        });
    }

    kpiList (params) {
        return this.client.request ({
            method: 'get',
            path: '/upyield/v2/analytics/dict-kpi/categories',
            params,
        });
    }

    kpiFraudList (params) {
        return this.client.request ({
            method: 'get',
            path: '/upyield/v2/analytics/dict-kpi-fraud/categories',
            params,
        });
    }

    report (params) {
        return this.client.download ({
            method: 'get',
            responseType: 'blob',
            path: '/upyield/v2/analytics/report/download',
            params,
        });
    }

    postbacks (params) {
        return this.client.request({
            method: 'get',
            path: '/upyield/v2/analytics/report/postbacks',
            params,
        });
    }

    events (params) {
        return this.client.request({
            method: 'get',
            path: '/upyield/v2/analytics/report/events',
            params,
        });
    }

    clicks (params) {
        return this.client.request({
            method: 'get',
            path: '/upyield/v2/analytics/report/clicks',
            params,
        });
    }

    blockedClicks (params) {
        return this.client.request({
            method: 'get',
            path: '/upyield/v2/analytics/report/blocked-clicks',
            params,
        });
    }

    advertiserPostbacks (params) {
        return this.client.request({
            method: 'get',
            path: '/upyield/v2/analytics/report/advertiser-postbacks',
            params,
        });
    }

    conversion (params) {
        return this.client.request({
            method: 'get',
            path: '/upyield/v2/analytics/conversion',
            params,
        });
    }

    reportDownload (type, params) {
        return this.client.download({
            method: 'get',
            responseType: 'blob',
            path: `/upyield/v2/analytics/report/${type}/download`,
            params,
        });
    }

    reportDownloadDirectGenerate (type, params) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v2/analytics/report/${type}/download/direct`,
            params,
        });
    }

    reportDownloadDirect (url, options) {
        return this.client.download({
            method: 'get',
            responseType: 'blob',
            url,
        }, options);
    }

    reportExport (type, params) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v2/analytics/download/${type}/export`,
            params,
        });
    }

    adjust (params) {
        return this.client.request({
            method: 'post',
            path: '/upyield/v2/analytics/adjust',
            params,
        });
    }

    adjustManually (data) {
        return this.client.request({
            method: 'post',
            path: '/upyield/v1/tasks/mass-adjust',
            data,
        }, { showErrorMessages: false });
    }
}

export default new AnalyticsResource;
